/*jshint scripturl:true*/
var maxScrollDepth = 0,
    scrollDepthSent = false;

$(document)
    .ready(function() {

        $.scrollDepth({
            pixelDepth: false,
            userTiming: false,
            eventHandler: function(data) {
                var scrollDepth = parseInt(data.eventLabel); // z.B. 25, 50, 75, 100
                if (scrollDepth > maxScrollDepth) {
                    maxScrollDepth = scrollDepth;
                }
                trackEvent(data.eventCategory, data.eventAction, data.eventLabel, data.eventValue, data.eventNonInteraction, "matomo");
            }
        });


        setTimeout(function() {
            var waAnalysis = {
                _tracking: false,
                _consent: {
                    mode: (advancedConsentMode) ? 'advanced' : 'simple',
                    values: (typeof consentObj != "undefined") ? consentObj : false
                },
                tools: []
            };
            // if ($.cookie('cookieConsented-analysis') == '1') {
            // waAnalysis._tracking = true;
            if ($('#google_analyticsJS').length) {
                waAnalysis._tracking = true;
                waAnalysis.tools.push({
                    'analyticsJS': ($('#gaCode').data('code') === '{$googleAnalyticsAccount}') ? 'extern (gtm, etc.)' : $('#gaCode').data('code')
                });
            }
            if ($('#google_gtag').length) {
                waAnalysis._tracking = true;
                waAnalysis.tools.push({
                    'gtag': ($('#gaCode').data('code') === '{$googleAnalyticsAccount}') ? 'extern (gtm, etc.)' : $('#gaCode').data('code')
                });
            }
            // }
            if ($('#matomoTracking').length) {
                waAnalysis._tracking = true;
                waAnalysis.tools.push({
                    'Matomo': $('#matomoTracking').data('id')
                });
            }
            if (waAnalysis._tracking) {
                console.table("%c TTG Debug ", "background: #0080a3; color: #fff", waAnalysis);
            }
        }, 500);

        // #mailto Anker in URL > Fancy Form Init opened < sofern vorhanden
        if (window.location.hash === '#mailto') {

            // Selektoren
            var $mailLink = $('[data-eventaction="Kontaktblock Mail"]').first();
            var $wrapper = $('.ttgFancyAnfrageWrapper');

            // Bedingungen prüfen
            if ($mailLink.length && $wrapper.length) {
                // Etwas warten, falls andere JS-Initialisierungen laufen
                setTimeout(function() {
                    $mailLink.trigger('click');
                }, 300);
            }
        }

    })
    .on('submit', '.ttgNewsKategorieFilterForm', function(e) {

        trackEvent('Redaktionelle Artikel / Liste', 'Filterung der Liste', '');

    })
    .on("click", "#ttgNCEHeaderSlider .right.carousel-control", function(e) {

        trackEvent('Global', 'Header Slider', 'Vor');

    })
    .on("click", "#ttgNCEHeaderSlider .left.carousel-control", function(e) {

        trackEvent('Global', 'Header Slider', 'Zurück');

    })
    .on("click", ".ttgVcard .ttgTrackShowPhone", function(e) {

        e.preventDefault();
        $('.ttgTelNrPartial').removeClass('ttgTelNrPartial').addClass('ttgTelNrPartialInactive');
        $('.ttgVcard .ttgTrackShowPhone').remove();
        trackEvent('Tourdata Events', 'Telefonnummer Link', 'viewed');

    })
    .on('click', 'a:not([data-eventCategory])', function(e) {

        // Nur ausführen, wenn Google Analytics aktiv ist
        if ($('.ttgDataWrapperOnlyNeededForJS').attr('data-googleanalyticsactive') == 1) {

            // Telefonnummern
            var href = $(this).attr('href');

            if (href.match("^tel:") && !$(this).hasClass('ttgNewsTelefonLink')) {

                trackEvent('Global', 'Kontaktblock Telefon', 'clicked');

            } else {

                // Nur ausführen, wenn es NICHT um eine TOURDATA-Detailseite handelt
                if ($('.ttgTourdataDetailSeite').length == 0) {

                    // REDAKTIONELLE ARTIKEL
                    // Liste
                    if ($(this).hasClass('ttgNewsListLink')) {
                        var artikelID = $(this).parent().attr('data-id');
                        var artikelTitle = $(this).parent().attr('data-titel');
                        trackEvent('Redaktionelle Artikel / Liste', 'Öffnen eines Artikels', artikelID + ' / ' + artikelTitle);
                    }

                    // Liste / Detailseite: E-Mail Adresse
                    if ($(this).hasClass('ttgNewsMailLink')) {
                        trackEvent('Redaktionelle Artikel / Kontaktblock', 'Klick auf E-Mail Adresse', href);
                    }

                    // Liste / Detailseite: Telefon
                    if ($(this).hasClass('ttgNewsTelefonLink')) {
                        trackEvent('Redaktionelle Artikel / Kontaktblock', 'Klick auf Telefonnummer', href);
                    }

                    /* Tracking ext. Links entfernt > OOEAT-5182
                    // Liste / Detailseite: Website
                    if ($(this).hasClass('ttgNewsWebLink')) {
                        trackEvent('Redaktionelle Artikel / Kontaktblock', 'Klick auf Website', href);
                    }
                    */

                    /* Tracking Download entfernt > OOEAT-5182
                    // Detailseite: Dokumente
                    if ($(this).hasClass('ttgNewsFiles')) {
                        trackEvent('Redaktionelle Artikel / Detail', 'Datei-Download', href);
                    }
                    */

                    // Detailseite: In Verbindung stehende Artikel
                    if ($(this).hasClass('ttgNewsVerwandteArtikel')) {
                        trackEvent('Redaktionelle Artikel / Detail', 'Klick auf in Verbindung stehenden Artikel', href);
                    }

                    // Detailseite: Weiterführende Links
                    if ($(this).parents().hasClass('ttgNewsWeiterfuehrendeLinks')) {
                        trackEvent('Redaktionelle Artikel / Detail', 'Klick auf weiterführenden Link', href);
                    }

                    // Detailseite: TOURPIX
                    if ($(this).hasClass('ttgNewsTourpixDownload')) {
                        trackEvent('Redaktionelle Artikel / Detail', 'Klick auf TOURPIX-Relation', href);
                    }

                    // Detailseite: Detaillierte Karte
                    if ($(this).hasClass('ttgNewsDetailKarte')) {
                        trackEvent('Redaktionelle Artikel / Detail', 'Klick auf detaillierte Karte', '');
                    }

                    // Mailto-Link
                    if (href.match("^anfrage")) {
                        var mailtoValue = $(this).text();
                        trackEvent('Global', 'Kontaktblock Mail', mailtoValue);
                    } // if

                    /* Tracking ext. Links entfernt > OOEAT-5182
                    // PDF-Download
                    var isPDF = $(this).attr('href').search('.pdf');

                    if (isPDF != "-1") {
                        trackEvent('Global', 'PDF Download', $(this).attr('href'));
                    } // if
                    */

                    // Social Share NCE
                    if ($(this).hasClass('ttgSocialShareLink')) {
                        trackEvent('Global', 'Social Sharing', 'Facebook NCE');
                    }

                    /* Tracking ext. Links entfernt > OOEAT-5182
                    // javascript:void(0)
                    // var isVoid = $(this).attr('href').search('javascript');

                    // if (isVoid == "-1") {

                    //     // Externe links
                    //     var getLocation = function(href) {
                    //         var l = document.createElement("a");
                    //         l.href = href;
                    //         return l;
                    //     };

                    //     var l = getLocation($(this).attr('href'));
                    //     var linkDomain = getHostname(l);

                    //     var baseURL = window.location.protocol + "//" + window.location.host;

                    //     if (baseURL != linkDomain) {

                    //         if ($(this).attr('href') != "javascript:void(0)") {
                    //             trackEvent('Global', 'Externer Link', $(this).attr('href'));
                    //         } // if

                    //     } // if

                    // } // if - javascript:void(0)
                    */

                } // if - TOURDATA-Detailseite

            } // if - Telefonnummer

        } // if - Google Analytics

    })
    .on('click', '[data-eventcategory]', function(e) {

        var trackerObj = $(this);
        if (trackerObj.data('eventcategory') && trackerObj.data('eventaction') && trackerObj.data('eventlabel')) {
            trackEvent(trackerObj.data('eventcategory'), trackerObj.data('eventaction'), trackerObj.data('eventlabel'));
        } else {
            if (!trackerObj.data('eventcategory')) {
                console.log('eventCategory has to be defined');
            }
            if (!trackerObj.data('eventaction')) {
                console.log('eventAction has to be defined');
            }
            if (!trackerObj.data('eventlabel')) {
                console.log('eventLabel has to be defined');
            }
        }

        // data-removeElement für Elemente, welche nach dem Klick entfernt werden sollen
        if (trackerObj.data('removeelement') == 1) {
            trackerObj.remove();
        }

    })

    .on('click', '.ttg-carousel-item a', function(e) {
        trackEvent('Global', 'NCE-Karussell', $(this).attr('href'));
    })

    // Formular Events
    .on("submit", "#ttgKatalogForm", function(e) {

        var kataloge = function() {

            var kat = '';
            $.each($('#ttgKatalogForm .ttgAuswahl .checkedCat'), function(k, v) {
                kat += (kat !== '') ? ', ' + $(this).data('catid') : $(this).data('catid');
            });
            return kat;

        };

        if ($('#ttgKatalogForm .ttgWanderkarteBestellenButton').length > 0) {
            // trackEvent('Formular', 'Wanderkarte bestellt', kataloge()); /* funkt. direkt über Button */
        } else {
            trackEvent('Formular', 'Prospekt bestellt', kataloge());
        }

    })
    // .on("submit", ".ttgWanderkarteBestellenButton", function(e) {

    //     trackEvent('Formular', 'Wanderkarte bestellt', $('#kataloge').val());

    // })

    // quickIcons
    .on('click', ".quickIconsHolder a, .quickIconsHolder #ttgQuickNaviMap > span", function(e) {

        trackEvent('Global', 'Quicklinks', $(this).find('.infotext').text());

    });

function getHostname(url) {

    url = url.toString();
    var m = url.match(/^http.?:\/\/[^/]+/);
    return m ? m[0] : null;

}

function trackEvent(eventCategory, eventAction, eventLabel, value, nonInteraction, pushOnly) {

    var dontTrack = {
        categories: [],
        actions: [
            'Externer Link', // Global
            'PDF Download', // Global || Katalogbestellung
            'Datei-Download', // Global
            'Outgoing Weblink', // Tourdata Events
            'Klick auf Website', // Redaktionelle Artikel / Kontaktblock
            // 'Angebot Buchen Link' // Tourdata Events
        ],
        labels: [],
        values: []
    };

    if (
        !dontTrack.categories.includes(eventCategory) &&
        !dontTrack.actions.includes(eventAction) &&
        !dontTrack.labels.includes(eventLabel) &&
        !dontTrack.values.includes(value)
    ) {
        var tracking = {
            _enable: false,
            _consent: {
                mode: (advancedConsentMode) ? 'advanced' : 'simple',
                values: (typeof consentObj != "undefined") ? consentObj : false
            },
            _f: 'trackEvent()',
            _tools: [],
            category: eventCategory,
            action: eventAction,
            label: eventLabel,
            value: (value === undefined) ? false : value,
            nonInteraction: (nonInteraction === undefined) ? false : nonInteraction
        };

        // if ($.cookie('cookieConsented-analysis') == '1') {
        tracking._enable = true;

        if (!pushOnly || pushOnly === "google") {
            if ($('#google_analyticsJS').length) { // EventTracking mit Analytics JS [old]

                tracking._tools.push('analyticsJS');
                try {
                    ga('send', 'event', tracking.category, tracking.action, tracking.label, tracking.value, {
                        nonInteraction: tracking.nonInteraction
                    });
                } catch (e) {
                    console.log('FEHLER im EventTracking: ga() nicht gefunden. Event kann nicht an Analytics gepusht werden.');
                }

            } else if ($('#google_gtag').length) { // EventTracking mit GTAG [new]

                tracking._tools.push('gtag');
                try {
                    gtag('event', tracking.action, {
                        'event_category': tracking.category,
                        'event_label': tracking.label,
                        'value': tracking.value,
                        'non_interaction': tracking.nonInteraction
                    });
                } catch (e) {
                    console.log('FEHLER im EventTracking: gtag() nicht gefunden. Event kann nicht an GA4 gepusht werden.');
                }

            }
        }
        // }

        if (!pushOnly || pushOnly === "matomo") {
            if ($('#matomoTracking').length) {
                tracking._enable = true;
                tracking._tools.push('Matomo');
                _paq.push(['trackEvent', tracking.category, tracking.action, tracking.label, tracking.value]);
            }
        }

        if (tracking._enable) {
            console.table("%c TTG Debug ", "background: #0080a3; color: #fff", tracking);
        }
    }
}

function trackSiteSearch(response, params, type) {
    var $pagination = $($(response)[4]);

    if ($('#matomoTracking').length) {
        if (params && params.q) {
            var trackSiteSearchVars = {
                _f: 'trackSiteSearch()',
                _tools: ["Matomo"],
                q: params.q,
                category: type,
                count: 0
            };

            if ($pagination.data('items')) {
                if ($pagination.data('active') == '0') {
                    trackSiteSearchVars.count = $pagination.data('items');
                }
            }

            _paq.push(['trackSiteSearch', trackSiteSearchVars.q, trackSiteSearchVars.type, trackSiteSearchVars.count]);
            console.table("%c TTG Debug ", "background: #0080a3; color: #fff", trackSiteSearchVars);
        }
    }
}

function tosc5tracking(e, cb) {

    // Webstream: sofern die Konstante tosc5TrackingPush2DataLayer gesetzt ist, wird das Callback Objekt in das DataLayer gepusht
    if ($('#tdAppBaseUrl').length && $('#tdAppBaseUrl').data('tosc5trackingpush2datalayer') == '1') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'tosc5Tracking': {
                event: e,
                obj: cb
            }
        });
        return false;
    }

    var category = 'TOSC5 [' + e + ']',
        action = '',
        label = '',
        value = 1;

    switch (e) {
        case 'pageChange':
            break;
        case 'pageLoad':

            // category += ' [' + e + ']';

            // Siehe https://feratel.atlassian.net/wiki/spaces/FDPI/pages/62556874/Event+onPageLoad
            // console.log(e, cb);

            action = '[' + cb.pageType + ']';

            switch (cb.pageType) {

                case 100:

                    action += ' ' + cb.pageTitle; // Unterkünfte
                    label = 'Ergebnisse';
                    break;

                case 101:

                    action += ' Unterkunft';
                    label = cb.pageTitle;
                    break;

                case 102:

                    action += ' ' + cb.pageTitle; // Erlebnisse||Skitickets
                    label = 'Ergebnisse';
                    break;

                case 103:

                    action += ' Erlebnis';
                    label = cb.pageTitle;
                    break;

                case 104:

                    action += ' ' + cb.pageTitle; // Veranstaltungen
                    label = 'Ergebnisse';
                    break;

                case 105:

                    action += ' Veranstaltung';
                    label = cb.pageTitle;
                    break;

                case 106:

                    action += ' ' + cb.pageTitle; // Infrastrukturen
                    label = 'Ergebnisse';
                    break;

                case 107:

                    action += ' Infrastruktur';
                    label = cb.pageTitle;
                    break;

                case 108:

                    action += ' ' + cb.pageTitle; // Prospekte
                    label = 'Ergebnisse';
                    break;

                case 9900:

                    action += ' Warenkorb';

                    label = '[' + cb.shoppingCart.transactionType + '] Transaktionstyp';
                    // label += (cb.shoppingCart.transactionType === 1) ? ' Buchung' : ' Buchung auf Anfrage';

                    value = (cb.shoppingCart.bookingInformation.prices.totalAmount > 0) ? cb.shoppingCart.bookingInformation.prices.totalAmount : 1;
                    break;

                case 9901:

                    action += ' Buchung';
                    action += ' > [' + cb.bookingConfirmation.transactionType + '] Transaktionstyp';
                    // action += (cb.bookingConfirmation.transactionType === 1) ? ' Buchung' : ' Buchung auf Anfrage';

                    label = 'Buchungsnummer: ' + cb.bookingConfirmation.transactionNumber;
                    value = (cb.bookingConfirmation.totalAmount > 0) ? cb.bookingConfirmation.totalAmount : 1;
                    break;

                default:

                    action += ' Page Type (nicht definiert)';
                    label = cb.pageTitle;

            }

            trackEvent(category, action, label, value);

            break;

        case 'userAction':

            // console.log(e, cb);
            // category += ' [' + e + ']';

            // Siehe !https://fdcwiki.deskline.net/display/CONNECTIVITY/Event+onUserAction
            // Siehe https://feratel.atlassian.net/wiki/spaces/CONNECTIVITY/pages/62429263/DE+Event+onUserAction
            var types = [
                /*0*/
                'Klick Tel.-Nr',
                /*1*/
                'Anfrage versandt',
                /*2*/
                'Anfrage Formular geöffnet',
                /*3*/
                'Interaktion', // wird eig. immer ausgeführt, wenn was geklickt wird
                /*4*/
                'Klick Webseite',
                /*5*/
                'Warenkorb geöffnet',
                /*6*/
                'Suche/Filterung',
                /*7*/
                'Prospekt',
                /*8*/
                'Objekt > Impression',
                /*9*/
                'Objekt > Klick',
                /*10*/
                'Warenkorb > Objekt hinzufügen',
                /*11*/
                'Warenkorb > Objekt entfernen'
            ], requestTypes, searchObjectTypes, itemTypes;

            action = '[' + cb.type + ']';
            if (cb.type <= 11) {
                action += ' ' + types[cb.type];
            } else {
                action += ' Type (nicht definiert)';
            }

            switch (cb.type) {
                case 0:
                case 4:

                    label = cb.parentName;
                    break;

                case 1:
                case 2:

                    requestTypes = [
                        /*0*/
                        'Liste - Anfragepool',
                        /*1*/
                        'Liste - Persönliche Beratung',
                        /*2*/
                        'Detail - Direktanfrage (simpel)',
                        /*3*/
                        'Detail - Direktanfrage (detailliert)',
                        /*4*/
                        'Detail - Anfrage (Verfügbarkeit)'
                    ];

                    action += ' > ' + '[' + cb.requestType + ']';
                    if (cb.requestType <= 4) {
                        action += ' ' + requestTypes[cb.requestType];
                    } else {
                        action += ' RequestType (nicht definiert)';
                    }

                    label = cb.name;
                    break;

                case 5: // kein sinnvoller Wert in Callback Objekt vorhanden

                    label = "Ansicht";
                    break;

                case 6:

                    searchObjectTypes = [
                        /*0*/
                        'Erlebnis',
                        /*1*/
                        'Unterkunft'
                    ];

                    var filter = (cb.hasFilter) ? 'mit' : 'ohne';

                    label = '[' + cb.searchObjectType + ']';
                    if (cb.searchObjectType <= 1) {
                        label += ' ' + searchObjectTypes[cb.searchObjectType] + ' (' + filter + ' Filter)';
                    } else {
                        label += ' SearchObjectType (nicht definiert) (' + filter + ' Filter)';
                    }

                    value = cb.resultCount;
                    break;

                case 7:

                    var actionType = [
                        /*0*/
                        'Ansicht',
                        /*1*/
                        'Download',
                        /*2*/
                        'Bestellung'
                    ];

                    action += ' > ' + '[' + cb.actionType + ']';
                    if (cb.actionType <= 2) {
                        action += ' ' + actionType[cb.actionType];
                    } else {
                        action += ' ActionType (nicht definiert)';
                    }

                    label = cb.brochureName + ' (' + cb.language + ')';
                    break;

                case 8:

                    itemTypes = [
                        /*0*/
                        'Unterkünfte',
                        /*1*/
                        'Erlebnisse/Zusatzleistungen',
                        /*2*/
                        'Prospekte',
                        /*3*/
                        'Veranstaltungen',
                        /*4*/
                        'Infrastrukturen/POIs',
                        /*5*/
                        'Packages/Specialangebote',
                    ];

                    label = '[' + cb.itemType + ']';
                    if (cb.itemType <= 5) {
                        label += ' ' + itemTypes[cb.itemType];
                    }
                    label += ' > ' + cb.itemName + ' (' + cb.lang + ')';
                    break;

                case 9:

                    itemTypes = [
                        /*0*/
                        'Unterkünfte',
                        /*1*/
                        'Erlebnisse/Zusatzleistungen',
                        /*2*/
                        'Veranstaltungen',
                        /*3*/
                        'Infrastrukturen/POIs',
                        /*4*/
                        'Packages/Specialangebote',
                    ];

                    label = '[' + cb.itemType + ']';
                    if (cb.itemType <= 4) {
                        label += ' ' + itemTypes[cb.itemType];
                    }
                    label += ' > ' + cb.itemName + ' (' + cb.lang + ')';
                    break;

                case 10:

                    label = 'ItemId: ' + cb.item.itemId;
                    break;

                case 11:

                    label = cb.item.serviceName + ' (' + cb.item.productName + ')';
                    break;

                default:

                    label = 'nicht definiert';
                // break;

            }

            if (cb.type !== 3) { // 3 ist nicht definiert - dürfte jeglicher Klick sein
                trackEvent(category, action, label, value);
                // console.log(e, cb);
            }

            break;

    }
}

function pushDataLayer(source, obj) {

    let dataLayerObj = {
        source: source
    }, catArr = [];

    if (source === "TOURDATA") {

        dataLayerObj.event = 'tourdata_ansicht';
        if (obj.KategorienCleaned && obj.KategorienCleaned.length) {
            $.each(obj.KategorienCleaned, function(k, v) {
                catArr.push(obj.object.metaSourceCategory.toLowerCase() + '_' + v.nameCleaned);
            });
        } else {
            catArr.push(obj.object.metaSourceCategory.toLowerCase());
        }
        dataLayerObj.tourdata_unterkategorie = catArr;

    } else if (source === "TTG News" || source === "Seiten/Magazin") {

        dataLayerObj.event = 'redaktioneller_beitrag_ansicht';
        if (obj && obj.length) {
            $.each(obj, function(k, v) {
                catArr.push(v.nameCleaned);
            });
        }
        dataLayerObj.redaktionell_kategorie = catArr;

        // } else if (source === "Seiten/Magazin") {

        //     // console.log(obj);
        //     dataLayerObj.event = 'redaktioneller_beitrag_ansicht';
        //     if (obj && obj.length) {
        //         $.each(obj, function(k, v) {
        //             catArr.push(v.nameCleaned);
        //         });
        //     } else {
        //         catArr.push("");
        //     }
        //     dataLayerObj.redaktionell_kategorie = catArr;
        //     // console.log(dataLayerObj);

    }

    let doubleCatCheck = true, // ENABLE, wenn nur eine Source gepusht werden soll (PRIOS: tourdata > ttgNews > seitenMagazin)
        tourdata = false, ttgNews = false, seitenMagazin = false;

    if (doubleCatCheck && window.dataLayer) {
        $.each(window.dataLayer, function(k, v) {
            if (v.source === "TOURDATA") {
                tourdata = true;
            }
            if (v.source === "TTG News") {
                ttgNews = true;
            }
            if (v.source === "Seiten/Magazin") {
                seitenMagazin = true;
            }
        });
    }

    if (dataLayerObj.event && ((doubleCatCheck && !tourdata && !ttgNews) || !doubleCatCheck)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayerObj);
        console.table("%c pushDataLayer() ", "background: #0080a3; color: #fff", dataLayerObj);
        $.each(catArr, function(k, v) {
            trackEvent('Interesse', dataLayerObj.source, v, 1);
        });
    }
}

// Scroll-Event senden (nur 1x pro Seite)
function sendMaxScrollDepth() {
    if (scrollDepthSent) return; // Verhindert Mehrfachsenden
    // Value: 0.25 / 0.5 / 0.75 / 1 für 25% / 50% / 75% / 100%
    var value = maxScrollDepth / 100;
    var label = maxScrollDepth + "%";
    if (maxScrollDepth > 0) {
        trackEvent("Scroll Depth", "Maximum", label, value, (maxScrollDepth > 50) ? false : true, "matomo");
        /* NonInteraction beeinflusst die BounceRate > wenn mehr als 50% gescrollt wurde, dann werten wir den User nicht mehr als Bounce >> nonInteraction=false */
        scrollDepthSent = true;
    }
}

// Trigger: pagehide (sicherster Trigger für "Seite wird verlassen" inkl. SPA & Mobile)
window.addEventListener('pagehide', sendMaxScrollDepth);
// Fallback: visibilitychange (für Kompatibilität mit alten Browsern)
document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'hidden') {
        sendMaxScrollDepth();
    }
});